import { render, staticRenderFns } from "./StatisticsReworksAdmissionsByFaculty.vue?vue&type=template&id=e3a55b72"
import script from "./StatisticsReworksAdmissionsByFaculty.vue?vue&type=script&lang=js"
export * from "./StatisticsReworksAdmissionsByFaculty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports